const roleHelper = require('../../../../src/graphql/schema/queries/helpers/role')
;(function () {
  angular
    .module('contrast.application.dashboard')
    .controller('ApplicationDashboardCtrl', ApplicationDashboardCtrl)

  function ApplicationDashboardCtrl(
    $scope,
    $q,
    $rootScope,
    $routeParams,
    $location,
    $translate,
    $uibModal,
    $window,
    permissions,
    reportFilterService,
    UserService,
    FeaturesFactory,
    ApplicationFactory,
    LicenseFactory,
    appLibrariesService,
    TagFactory,
    CurrentApplicationService,
    ErrorService,
    FeaturesService,
    LanguagesService,
    LibrariesStatsVisibilityService,
    LicenseService,
    APPLICATION_LICENSES,
    FILTER_GROUPS,
    AGENT_LANGUAGE,
    AGENT_FEATURE
  ) {
    'ngInject'

    function init() {
      FeaturesFactory.getOssInventoryFeature($routeParams.orgUuid).then(
        function (data) {
          $scope.ossInventory = data.data.enabled
        }
      )

      FeaturesFactory.getOssFeature($routeParams.orgUuid).then(function (data) {
        $scope.oss = data.data.enabled
      })

      $scope.showArchiveDialog = false
      loadTags()
      getLicenses()

      _initApplicationOnChangeListener()

      $scope.loadAppPromise = false
      getApplication().then(function () {
        $scope.loadAppPromise = true
        $scope.isAssessLanguageSupported =
          FeaturesService.isAgentFeatureEnabled(
            AGENT_FEATURE.ASSESS,
            $scope.model.app.language,
            true
          )
        $scope.isProtectLanguageSupported =
          FeaturesService.isAgentFeatureEnabled(
            AGENT_FEATURE.PROTECTION,
            $scope.model.app.language,
            true
          )
        $scope.isProxySupported = LanguagesService.isProxy(
          $scope.model.app.language
        )
        $scope.showActivityTab = !(
          _.includes(AGENT_LANGUAGE.RUBY, $scope.model.app.language) ||
          _.includes(AGENT_LANGUAGE.DOTNET, $scope.model.app.language) ||
          _.includes(AGENT_LANGUAGE.DOTNET_CORE, $scope.model.app.language) ||
          _.includes(AGENT_LANGUAGE.GO, $scope.model.app.language) ||
          _.includes(AGENT_LANGUAGE.PYTHON, $scope.model.app.language) ||
          _.includes(AGENT_LANGUAGE.NODE, $scope.model.app.language) ||
          _.includes(AGENT_LANGUAGE.PHP, $scope.model.app.language)
        )
        $scope.showObserveTab =
          (_.includes(AGENT_LANGUAGE.JAVA, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment('PROD-2353_observe') ===
              'on') ||
          (_.includes(AGENT_LANGUAGE.GO, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment(
              'PROD-2353_observe-enable-go'
            ) === 'on') ||
          (_.includes(AGENT_LANGUAGE.DOTNET, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment(
              'ADR-305_observe-enable-dotnet'
            ) === 'on') ||
          (_.includes(AGENT_LANGUAGE.DOTNET_CORE, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment(
              'ADR-305_observe-enable-dotnet-core'
            ) === 'on') ||
          (_.includes(AGENT_LANGUAGE.PYTHON, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment(
              'ADR-305_observe-enable-python'
            ) === 'on') ||
          (_.includes(AGENT_LANGUAGE.NODE, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment(
              'ADR-305_observe-enable-node'
            ) === 'on') ||
          (_.includes(AGENT_LANGUAGE.PHP, $scope.model.app.language) &&
            $rootScope.splitClient.getTreatment(
              'ADR-305_observe-enable-php'
            ) === 'on')
      })

      $scope.$on('application:reload', function () {
        $scope.loadAppPromise = false
        getApplication().then(function () {
          $scope.loadAppPromise = true
        })
      })
    }

    angular.extend($scope, {
      model: {
        appLibStatsVisible: LibrariesStatsVisibilityService.model,
        appLibStatsLoaded: false,
        appId: $routeParams.appId
      },
      libraries: {},
      libraries_stats: {},
      libraries_vulns: null,
      loadAppPromise: false,
      oss: false,
      ossInventory: false,
      isAssessLanguageSupported: false,
      isProtectLanguageSupported: false,
      isProxySupported: false,
      agentLanguages: AGENT_LANGUAGE,

      deleteTag: deleteTag,
      tagApplication: tagApplication,
      goToVulnTrendChart: goToVulnTrendChart,
      applyLicense: applyLicense,

      updateDisplayName: updateDisplayName,
      clearDisplayNameError: clearDisplayNameError,

      openSettings: openSettings,
      showReportsDropdown: showReportsDropdown,
      getEmptyStateConfigKey: getEmptyStateConfigKey,
      isAppUnlicensed: isAppUnlicensed,
      hasAppPermission: hasAppPermission,
      isSampleApplication: isSampleApplication,

      getPolicyRoute: getPolicyRoute,
      getStats: getStats,
      setStatsLoaded: setStatsLoaded,

      getMostPermissiveRole: getMostPermissiveRole,
      closeArchiveDialog: closeArchiveDialog,
      getAgentFeatures: getAgentFeatures,
      hasAssessLicenses: hasAssessLicenses,
      reloadApplication: reloadApplication,
      link_routeCoverage: $translate.instant('link_routeCoverage'),
      refreshPage: refreshPage
    })

    function _initApplicationOnChangeListener() {
      var deregisterFn = CurrentApplicationService.onChange(function (app) {
        $scope.model.app = app
        $scope.application = app
      })
      $scope.$on('$destroy', deregisterFn)
    }

    function getMostPermissiveRole() {
      return permissions.getMostPermissiveRole()
    }

    function getAgentFeatures() {
      return FeaturesService.getAll()
    }

    function reloadApplication() {
      $rootScope.$broadcast('application:reload')
    }

    function loadTags() {
      return TagFactory.getApplicationTags($routeParams.appId).then(
        function (response) {
          $scope.tags = response.data.tags
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function hasAssessLicenses() {
      return $scope.breakdown.unused > 0
    }

    function getLicenses() {
      return LicenseFactory.getAssessmentBreakdown().then(
        function (response) {
          $scope.breakdown = response.data.breakdown
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getApplication() {
      return CurrentApplicationService.init($routeParams.appId).then(function (
        app
      ) {
        $scope.model.app = app
        $scope.application = app
        $scope.appRole = roleHelper.transformRole(app.roles)

        var roles = app.roles
        permissions.updateAppPermissions($routeParams.appId, roles)

        $rootScope.$broadcast('application:overview:load')
      })
    }

    function deleteTag(data) {
      return TagFactory.deleteApplicationTags($routeParams.appId, data).then(
        function (response) {
          $scope.tags = response.data.tags
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function tagApplication() {
      var transl = {
        title_applicationDashboard_tagApplication: $translate.instant(
          'title_applicationDashboard_tagApplication'
        )
      }

      $uibModal
        .open({
          templateUrl: 'views/tags/modal_tag.html',
          controller: 'AppTagModalCtrl',
          size: 'full',
          resolve: {
            applications: function () {
              return [$scope.model.app]
            },
            title: function () {
              return transl.title_applicationDashboard_tagApplication
            }
          }
        })
        .result.then(loadTags)
    }

    function showReportsDropdown() {
      if ($scope.model.app.license.level == APPLICATION_LICENSES.UNLICENSED) {
        $uibModal
          .open({
            templateUrl: 'views/applications/modal_reports_license.html',
            controller: 'AppLicenseModalInstanceCtrl',
            size: 'md',
            resolve: {
              app: function () {
                return $scope.model.app
              },
              licenses: function () {
                return $scope.breakdown
              }
            }
          })
          .result.then(function () {
            init()
            $rootScope.$broadcast('roles:updated')
          })
      }
    }

    function goToVulnTrendChart() {
      var group =
        $scope.model.app.license.level == APPLICATION_LICENSES.LICENSED
          ? FILTER_GROUPS.LICENSED
          : FILTER_GROUPS.UNLICENSED
      reportFilterService.setApplications([
        {
          value: $scope.model.appId,
          name: $scope.model.app.name,
          group: group
        }
      ])
      reportFilterService.setIsFromAppPage(true)
      $location.path(UserService.buildUrl('/reports/view'))
    }

    function applyLicense() {
      if (
        $scope.model.app.license.level !== APPLICATION_LICENSES.LICENSED &&
        $scope.breakdown.unused > 0
      ) {
        LicenseService.applyAssessLicense(
          $scope.model.app,
          $scope.breakdown
        ).then(function () {
          getApplication()
          getLicenses()
          $rootScope.$broadcast('roles:updated')
          $rootScope.$broadcast('app.licensed')
        })
      } else {
        LicenseService.noAvailableLicenses()
      }
    }

    function updateDisplayName(data, model) {
      if (model.app.name != data && data.length > 0) {
        return ApplicationFactory.updateDisplayName($scope.model.appId, data)
          .then(function () {
            model.app.name = data
            $scope.$broadcast('updateAppDisplayNameFromHeader', data)
            return $q.resolve(true)
          })
          .catch(function (response) {
            if (response.status === 409) {
              $scope.model.displayNameError = response.data.messages[0]
              return $q.reject(response.data.messages[0])
            }
          })
      } else {
        // if the new value is empty or same with old value, reject
        return false
      }
    }

    function clearDisplayNameError() {
      $scope.model.displayNameError = undefined
    }

    function openSettings() {
      $uibModal
        .open({
          templateUrl: 'views/applications/modal_settings.html',
          controller: 'AppSettingsModalCtrl',
          resolve: {
            application: function () {
              return $scope.model.app
            },
            isAssessLanguageSupported: function () {
              return $scope.isAssessLanguageSupported
            }
          },
          size: 'md'
        })
        .result.then(function (action) {
          if (action === 'archive') {
            $scope.showArchiveDialog = true
          } else {
            init()
            $rootScope.$broadcast('app:update')
          }
        })
    }

    function closeArchiveDialog() {
      $scope.showArchiveDialog = false
    }

    function refreshPage() {
      $window.location.reload()
    }

    function getEmptyStateConfigKey() {
      if ($scope.application.defend) {
        return 'appAttacks'
      }
      return 'appAttacksNoProtect'
    }

    function isAppUnlicensed() {
      return (
        $scope.loadAppPromise &&
        $scope.model.app.license.level == APPLICATION_LICENSES.UNLICENSED
      )
    }

    function hasAppPermission(permission) {
      if ($scope.application) {
        return permissions.hasAppPermission(
          $scope.application.app_id,
          permission
        )
      }
      return false
    }

    function isSampleApplication() {
      return (
        angular.isDefined($scope.application) &&
        $scope.application.app_id == UserService.getSampleApplicationID()
      )
    }

    function getPolicyRoute() {
      if (!$scope.isProxySupported) {
        return 'appDashboard.assess'
      }

      if (
        $scope.isProtectLanguageSupported &&
        $scope.model.app &&
        !$scope.model.app.parentApplicationId &&
        permissions.isRASPEnabled()
      ) {
        return 'appDashboard.protection'
      }

      return 'appDashboard.exclusions'
    }

    function getStats() {
      if (!$scope.model.appLibStatsLoaded) {
        appLibrariesService
          .getLibrariesStats($scope.model.appId)
          .then(function (stats) {
            $scope.libraries_stats = stats
            $scope.libraries_vulns = stats.total_vulnerabilities > 0

            setStatsLoaded(true)
          })
      }
    }

    function setStatsLoaded(isLoaded) {
      $scope.model.appLibStatsLoaded = isLoaded
    }

    init()
  }
})()
